/**
 * According to marketing team some braze events (lead_created and qw_complete) are not being properly logged 100% of the time. The Braze feedback
 * was to try to add a delay between the moment the user profile is created (and email attribute is added) and these events being sent.
 * See https://simplisafe.atlassian.net/browse/ECP-6626 for more info.
 */
export const EVENTS_LOGGING_DELAY = 8000
export const UPDATE_LEADS_DATA_DELAY = 1000
